<template>
  <a href="#" class="nav-link" @click.prevent="copyURL">
    <slot>
      <div class="icon-bg">
        <Icon name="copyLink" width="26" />
      </div>
      <div class="name" v-if="!hideLabel">{{$t('pages.checkins_detail.copy')}}</div>
    </slot>
  </a>
</template>
<script>

export default {
  name: "CopyText",
  props: {
    clipboard: {
      type: String,
      required: true
    },
    confirmTitle: {
      type: String,
      required: false
    },
    confirmMessage: {
      type: String,
      required: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async copyURL() {
      let copied = false
      try {
        await navigator.clipboard.writeText(this.clipboard);
        copied = true
      } catch (e) {
        console.error(e)
      } finally {
        this.$bvToast.toast(copied ? this.confirmMessage : 'Unable to copy', {
          title: copied ? this.confirmTitle : null,
          headerClass: 'd-block',
          variant: copied ? 'primary' : 'danger',
          toastClass: 'custom-toast-info-icon',
          autoHideDelay: 3000,
        })
      }
    }
  }
}
</script>
<style scoped>

</style>